/**
 * An instance of Hotkeys that can be used to enable, disable or register custom hotkeys in the viewer.
 * @name UI.hotkeys
 * @see UI.Hotkeys
 * @type {Class<UI.Hotkeys>}
 */

import hotkeysManager from 'helpers/hotkeysManager';
import { Keys } from 'helpers/hotkeysUtils';

export default {
  on: (...args) => {
    hotkeysManager.on(...args);
  },
  off: (...args) => {
    hotkeysManager.off(...args);
  },
  /**
   * Restores the hotkeys to default and disables previously unbinded hotkeys.
   * @ignore
   */
  restoreHotkeys: () => {
    hotkeysManager.restoreHotkeys();
  },
  Keys,
};
